/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BridgeStatusView } from './BridgeStatusView';
export type DataSourceView = {
    host: string;
    port: number;
    database: string;
    username: string;
    password: string;
    /**
     * `direct` — backend connects to MSSQL itself; `bridge` — via the Wawi Bridge agent (connection fields are empty)
     */
    type?: DataSourceView.type;
    bridge?: BridgeStatusView | null;
};
export namespace DataSourceView {
    /**
     * `direct` — backend connects to MSSQL itself; `bridge` — via the Wawi Bridge agent (connection fields are empty)
     */
    export enum type {
        DIRECT = 'direct',
        BRIDGE = 'bridge',
    }
}

